import { useState } from 'react';
import '../../assets/css/mobile-menu.css';

export default function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    return (
        <>
            {!isOpen && (
                <button className="mobile-menu__toggle" onClick={toggleMenu} aria-label="Toggle menu">
                    <span className={`mobile-menu__hamburger ${isOpen ? 'mobile-menu__hamburger--open' : ''}`}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            )}
            {isOpen && <div className="mobile-menu__overlay" onClick={closeMenu} />}
            <div className={`mobile-menu__sidebar ${isOpen ? 'mobile-menu__sidebar--open' : ''}`}>
                <div className="mobile-menu__content">
                    <div className="mobile-menu__header">
                        <h3>NAVO Sổ Tiệm</h3>
                        <button className="mobile-menu__close" onClick={closeMenu} aria-label="Close menu">
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <nav className="mobile-menu__nav">
                        <a href="/trang-chu" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-house"></i> Trang chủ
                        </a>
                        <a href="/#features" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-grip"></i> Tính năng
                        </a>
                        <a href="/#pricing" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-tag"></i> Bảng giá
                        </a>
                        <a href="/#contact" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-envelope"></i> Liên hệ
                        </a>
                        <a href="/#faq" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-circle-question"></i> Câu hỏi
                        </a>
                        <a href="/chinh-sach-bao-mat" className="mobile-menu__link" onClick={closeMenu}>
                            <i className="fa-solid fa-shield-halved"></i> Chính sách & Bảo mật
                        </a>
                    </nav>
                    <div className="mobile-menu__footer">
                        <div className="mobile-menu__contact">
                            <p><i className="fas fa-phone"></i> 0886.299.670</p>
                            <p><i className="fas fa-envelope"></i> navosotiem@gmail.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
